import { render, staticRenderFns } from "./kaitongvip.vue?vue&type=template&id=a8cbb2d8&scoped=true&"
import script from "./kaitongvip.vue?vue&type=script&lang=js&"
export * from "./kaitongvip.vue?vue&type=script&lang=js&"
import style0 from "./kaitongvip.vue?vue&type=style&index=0&id=a8cbb2d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cbb2d8",
  null
  
)

export default component.exports